module.exports = __webpack_public_path__ + "assets/favicons/safari-pinned-tab.svg";